export type AttachmentResource =
  | 'qms_record'
  | 'maintenance_order'
  | 'maintenance_record'
  | 'calibration_record'
  | 'equipment'
  | 'document_version'
  | 'supplier'
  | 'context'
  | 'risk'
  | 'objective'
  | 'indicator'
  | 'audit'
  | 'audit_finding'
  | 'legal_requirement'
  | 'training_session'
  | 'management_review'
  | 'info_asset'
  | 'soa_control'
  | 'safety_incident'
  | 'environmental_aspect'
  | 'change_request'
  | 'emergency_plan'
  | 'emergency_drill'
  | 'user';

export type AttachmentStatus = 'pending' | 'ready' | 'failed';

export interface AttachmentUser {
  id: number;
  email: string;
  role: string;
}

export interface Attachment {
  id: string;
  resourceType: AttachmentResource;
  resourceId: string;
  objectKey: string;
  fileName: string;
  mimeType: string;
  sizeBytes: number;
  etag?: string | null;
  status: AttachmentStatus;
  uploadedById?: number | null;
  uploadedBy?: AttachmentUser | null;
  createdAt: string;
  updatedAt: string;
  initExpiresAt: string;
}

export interface InitUploadReq {
  resourceType: AttachmentResource;
  resourceId: string;
  fileName: string;
  mimeType: string;
  sizeBytes: number;
}

export interface InitUploadRes {
  attachmentId: string;
  uploadUrl: string;
  expiresIn: number;
}

export interface DownloadUrlRes {
  url: string;
  fileName: string;
  expiresIn: number;
}

export const ATTACHMENTS_MAX_BYTES = Number(
  import.meta.env.VITE_ATTACHMENTS_MAX_BYTES ?? 104857600,
);
